$(document).ready(function () {
	$('.survey__row').first().addClass('survey__row--active');
})

$('.survey__radiobtn').change(function(){
	$(this).parents('.survey__row').find('.survey__radiobtn').each(function(){
      $(this).next('label').removeClass('survey__label--checked');
      $(this).next('label').removeClass('survey__label--unchecked');
      if($(this).is(':checked')) {
      	$(this).next('label').addClass('survey__label--checked');
      } else {
      	$(this).next('label').addClass('survey__label--unchecked');
      }
	});
	
	if($(this).parents('.survey__row').hasClass('survey__row--active')) {
		$(this).parents('.survey__row').next('.survey__row').addClass('survey__row--active');
		
		$([document.documentElement, document.body]).animate({
        scrollTop: $(this).parents('.survey__row').next('.survey__row').offset().top-50
   	}, 500);
	}
});


// WEBPACK FOOTER //
// ./app/src/assets/js/partials/radioCheck.js